// @flow
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import style from '../Payouts.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import formStyle from '../../../../../assets/styles/form.scss';
import boxStyle from '../../../../../assets/styles/box.scss';

import type { Node } from 'react';

type Props = {
  staticMap: Node;
  countryContent: Node;
  disabled: boolean;
  handleSubmit: (e: Event) => void;
};

const messages = defineMessages({
  button: {
    next: {
      id: 'preferences.payouts.button.next',
    },
  },
});

export default class CountryStep extends Component<Props> {

  render() {
    const { staticMap, countryContent, disabled, handleSubmit } = this.props;
    return (<section className={style.countryStep}>
      <FormattedMessage id="preferences.payouts.stepCountry.title">{
        txt => <h2 className={classNames(boxStyle.boxTitle, boxStyle.smallSpace)}>{txt}</h2>
      }</FormattedMessage>
      <FormattedMessage id="preferences.payouts.stepCountry.subtitle">{
        txt => <p className={boxStyle.subtitle}>{txt}</p>
      }</FormattedMessage>
      <div>{staticMap}</div>
      <form className={classNames(formStyle.formWrap, style.countryForm)}>
        {countryContent}
        <FormattedMessage id={messages.button.next.id}>{
          txt => <button type="button"
                         disabled={disabled}
                         className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                         onClick={handleSubmit}>
            {txt}</button>
        }</FormattedMessage>
      </form>
    </section>);
  }
}

CountryStep.propTypes = {
  staticMap: PropTypes.node.isRequired,
  countryContent: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/preferences/payouts/components/CountryStep/CountryStep.jsx